










import { QualityGoalType } from '@/interfaces/types/QualityGoal';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    qualityGoal: { type: Object as PropType<QualityGoalType> },
  },
});
